import React from "react"
import { Col, Form } from "react-bootstrap"

function ReactSwitch(props) {
  return (
    <div>
      <Col md={props.col}>
        <Form.Group>
          <Form.Check
            type="switch"
            id={props.id}
            name={props.name}
            label={props.label}
            checked={props.checked}
            onChange={props.onChange}
          />
        </Form.Group>
      </Col>
    </div>
  )
}

export default function Switch(props) {
  const {name,id,label, value,setFieldValue} = props

  function handleChange(){
    let fieldValue = value;
    setFieldValue(name,!fieldValue);
  }



  return (
      <ReactSwitch
        name={name}
        label={label}
        id={id}
        checked={value ? ('checked'):''}
        onChange={handleChange}
      />
  )
}
